import { render } from "./PlaceholderSelect.vue?vue&type=template&id=35731168&scoped=true&ts=true"
import script from "./PlaceholderSelect.vue?vue&type=script&lang=ts"
export * from "./PlaceholderSelect.vue?vue&type=script&lang=ts"

import "./PlaceholderSelect.vue?vue&type=style&index=0&id=35731168&scoped=true&lang=css"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35731168"]])

export default __exports__